import {createQueryString} from "@variocube/app-ui";
import {useMemo} from "react";
import {TypeOf} from "zod";
import {useClientId} from "../ClientIdProvider";
import {createApiClientWithBaseConfig, getBaseUrl} from "./client";
import {get_Login, get_Logout, RefreshTokenQuery, TokenQuery} from "./client.gen";

export function useAuthApi() {
	const clientId = useClientId();
	return useMemo(() => createAuthApi(clientId), []);
}

function createAuthApi(clientId: string | undefined) {
	const {api, withConfig} = createApiClientWithBaseConfig(clientId, undefined);
	return {
		getToken: (query: TokenQuery) =>
			api.post(
				"/api/auth/token",
				withConfig({
					body: query,
				}),
			),
		refreshToken: (query: RefreshTokenQuery) =>
			api.post(
				"/api/auth/refresh",
				withConfig({
					body: query,
				}),
			),
		redirectToLogin: (query: TypeOf<get_Login["parameters"]>["query"]) => {
			location.href = `${getBaseUrl()}/api/auth/login?${createQueryString(query)}`;
		},
		redirectToLogout: (query: TypeOf<get_Logout["parameters"]>["query"]) => {
			location.href = `${getBaseUrl()}/api/auth/logout?${createQueryString(query)}`;
		},
	};
}
